import React from 'react';
import PropTypes from 'prop-types';
import GenericIcon from './fontIcons/genericIcon';
import './fontIcons/fontIconStyle.css';

const ModifyIcon = ({ ...props }) => {
  const { color, size } = props;
  return <GenericIcon color={color} size={size} fontClass="icon-ic_editar" />;
};

ModifyIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export default ModifyIcon;
